<template>
    <layout>
        <!-- Start Banner Area -->
        <div class="slider-one rn-section-gapTop">
            <div class="container">
                <div class="row row-reverce-sm align-items-center">
                    <div class="col-lg-5 col-md-6 col-sm-12 mt_sm--50">
                        <h2 class="title" data-sal-delay="200" data-sal="slide-up" data-sal-duration="800">
                            Matrix Power
                        </h2>
                        <p class="slide-disc" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
                            {{ $t('home.banner_desc') }}
                        </p>
                        <!-- <div class="button-group">
                            <router-link class="btn btn-large btn-primary" to="#" data-sal-delay="400" data-sal="slide-up" data-sal-duration="800">
                                Get Started
                            </router-link>
                            <router-link class="btn btn-large btn-primary-alta" to="/create" data-sal-delay="500" data-sal="slide-up" data-sal-duration="800">
                                Create
                            </router-link>
                        </div> -->
                    </div>
                    <div class="col-lg-5 col-md-6 col-sm-12 offset-lg-1">
                        <div class="slider-thumbnail" style="display: flex;">
                            <img :src="require(`@/assets/images/slider/slider-1.png`)" alt="Slider Images">
                            <!-- <img  style="width: 100rem;" :src="require(`@/assets/images/slider/slider-2.png`)" alt="Slider Images"> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="container">
                <div class="card-group">
                    <div class="card-item">
                        <div class="card-img">
                            <img src="@/assets/images/homeBg/home1.png" />
                        </div>
                        <div class="card-home">
                            <h3 class="card-title">{{ $t('home.accordion.title1') }}</h3>
                            <p class="card-desc">{{ $t('about.company_profile') }}</p><a href="#"
                                class="card-link">{{ $t('home.discover') }}</a>
                        </div>

                    </div>
                    <div class="card-item">
                        <div class="card-img"><img src="@/assets/images/homeBg/home2.png" />
                        </div>
                        <div class="card-home">
                            <h3 class="card-title">{{ $t('home.card.ai_quant') }}</h3>
                            <p class="card-desc">{{ $t('quantify.introduction') }}{{ $t('quantify.winRate') }}{{ $t('quantify.transaction') }}</p><a
                                href="#" class="card-link">{{ $t('home.discover') }}</a>
                        </div>

                    </div>
                    <div class="card-item">
                        <div class="card-img">
                            <img class="card-imgs" src="@/assets/images/homeBg/home1.png" />
                        </div>
                        <div class="card-home">
                            <h3 class="card-title">{{ $t('home.card.app_download') }}</h3>
                            <p class="card-desc">{{ $t('home.card.app_matrix_desc') }}</p><a href="#"
                                class="card-link">{{ $t('home.discover') }}</a>
                        </div>

                    </div>
                    <div class="card-item">
                        <div class="card-img">
                            <img src="@/assets/images/homeBg/home1.png" />
                        </div>
                        <div class="card-home">
                            <h3 class="card-title">{{ $t('home.card.contact_us') }}</h3>
                            <p class="card-desc">{{ $t('about.company_profile') }}</p><a href="#"
                                class="card-link">{{ $t('home.discover') }}</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="about-us" style="width: 100%">
            <h2 style="margin-bottom: 80px;">{{ $t('about.titleName1') }}</h2>
            <div class="accordion-item" v-for="(item, index) in accordionList" :key="index">
                <div class="accordion-header" @click="toggleItem(index)">
                    <span>{{ item.title }}</span>
                    <i class="icon" :class="{ 'active': item.isOpen }">+</i>
                </div>
                <div class="accordion-content" v-show="item.isOpen">
                    <p>{{ item.content }}</p>
                </div>
            </div>
        </div>
        <div class="partner-section">
            <h2 class="section-title">{{ $t('home.partner.title') }}</h2>
            <p class="section-subtitle">{{ $t('home.partner.slogan') }}</p>
            <div class="partner-list">
                <div style="display: flex;justify-content: center;">
                    <div class="partner-item"  :key="index">
                    <img src="@/assets/images/logo/icon_home_hezuo_one@3x.png" class="partner-logo">
                </div>
                <div class="partner-item"  :key="index">
                    <img src="@/assets/images/logo/icon_home_hezuo_two@3x.png" class="partner-logo">
                </div>
                </div>
                <div  style="display: flex;justify-content: center;">
                    <div class="partner-item"  :key="index">
                    <img src="@/assets/images/logo/icon_home_hezuo_three@3x.png" class="partner-logo">
                </div>
                <div class="partner-item"  :key="index">
                    <img src="@/assets/images/logo/icon_home_hezuo_four@3x.png" class="partner-logo">
                </div>
                </div>
               
               
            </div>
            <!-- 留白区域 -->
            <div class="space-block"></div>
        </div>
        <!-- End Banner Area -->

        <!-- Start Live Bidding Area -->
        <!-- <explore-live-carousel/> -->
        <!-- End Live Bidding Area -->

        <!-- Start Service Area -->
        <!-- <service-style-one/> -->
        <!-- End Service Area -->

        <!-- Newest Items Area Start -->
        <!-- <explore-newest-item/> -->
        <!-- Newest Items Area End -->

        <!-- Top Seller Start -->
        <!-- <seller-style-one/> -->
        <!-- Top Seller End -->

        <!-- Explore Product Area Start -->
        <!-- <explore-filter/> -->
        <!-- Explore Product Area End -->

        <!-- Collection Area Start -->
        <!-- <collection-style-one/> -->
        <!-- Collection Area End -->

        <share-modal />

        <report-modal />
    </layout>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

// 获取 i18n 核心方法和变量
const { t, locale } = useI18n() 

</script>
<style scoped lang="scss">
.container {
    /* background-color: #1f2937; */
    padding: 1.25rem;
    color: #fff;
}

.card-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 1.25rem;
}

.card-item {
    width: calc(46% - .625rem);
    background-color: #27313D;
    padding: 1.25rem;
    border-radius: .5rem;
    box-sizing: border-box;
    margin-top: 20rem;
    padding-bottom: 3rem;
}

.card-img {
    margin-bottom: .9375rem;
    overflow: hidden;
    border-radius: .25rem;
    position: relative;
    top: -15rem;
    width: 100%;
    display: flex;
    justify-content: center;

}

.card-home {
    margin-top: -100px;
    margin-left: 40px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card-img img {
    width: 57.5rem;
    height: auto;
    display: block;
}

.card-title {
    font-size: 2.125rem;
    margin-bottom: .625rem;
    font-weight: 600;
}

.card-desc {
    font-size: 14px;
    color: #9ca3af;
    margin-bottom: 1.25rem;
    line-height: 1.5;
}

.card-link {
    font-size: 14px;
    color: #FFD200;
    text-decoration: none;
    display: inline-block;
}

@media (max-width: 768px) {
    .card-item {
        width: 100%;
    }
}

.about-us {

    color: #ecf0f1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.about-us h2 {
    text-align: center;
    margin-bottom: 20px;
    position: relative;

}

.about-us h2::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background-color: #f1c40f;
}

.accordion-item {
    border-bottom: 1px solid #34495e;
    width: calc(57%);
    min-width: 35rem;
    background-color: #171524;

}

.accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    padding-left: 1rem;
    padding-right: 1.875rem;
    height: 8rem;
    cursor: pointer;
}

.accordion-header .icon {
    transition: transform 0.3s ease;
}

.accordion-header .icon.active {
    transform: rotate(45deg);
}

.accordion-content {
    padding-bottom: 15px;
    padding-left: 1.875rem;
}
.partner-section {
  background-color: #171524; /* 匹配界面深蓝色 #1A2A47 */
  padding: 40px 20px;
  text-align: center;
}

.section-title {
  color: #FFFFFF;
  font-size: 24px;
  margin-bottom: 10px;
}

.section-subtitle {
  color: #C0C5CD;
  font-size: 14px;
  margin-bottom: 30px;
}

.partner-list {
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
  gap: 20px;
  margin-bottom: 40px; /* 与留白区域的间距 */
  margin: 0 auto;
  
}

.partner-item {
  width: calc(15% ); /* 两列布局，适配H5 */
  min-width: 15rem;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.partner-logo {
  max-width: 100%;
  height: auto;
}

.space-block {
  height: 60px; /* 留白高度，可自定义 */
  background-color: #171524;
}

/* ========== H5 适配补充（不影响桌面端） ========== */
@media (max-width: 768px) {
    /* 顶部 banner */
    .slider-one .title { font-size: 34px; }

    /* 卡片区：取消桌面端大偏移的交叠布局 */
    .card-item {
        width: 100%;
        margin-top: 8rem;
        padding-bottom: 2rem;
    }
    .card-img { top: -6rem; }
    .card-img img { width: 100%; }
    .card-home {
        margin-top: -60px;
        margin-left: 0;
        height: auto;
        gap: 14px;
    }
    .card-title { font-size: 24px; }

    /* 手风琴：收窄宽度与高度 */
    .accordion-item {
        width: 100%;
        min-width: 0;
    }
    .accordion-header {
        height: auto;
        padding: 15px 12px;
    }
    .accordion-content {
        padding-left: 12px;
        padding-right: 12px;
    }

    /* 合作伙伴：两列铺满 */
    .partner-item {
        width: calc(50% - 10px);
        min-width: 0;
    }
}
</style>